import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import ProgressBarComponent from 'WebsiteApp/elements/shared/ProgressBarComponent';
import axios from 'axios';
import { InputField } from 'WebsiteApp';
import Config from 'WebsiteApp/config';
import _ from 'lodash';

const STATUS_OLD = 'old';
const STATUS_NEW = 'new';
const STATUS_UPLOADING = 'uploading';
const STATUS_QUEUED = 'queued';
const STATUS_REMOVED = 'removed';


export default class AppUploadField extends React.Component {

  state = {
    files: [],
  }


  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  handleDrop = acceptedFiles => {
    this._addFiles(acceptedFiles);
  }

  _addFiles(acceptedFiles) {
    let parsedFiles = [];

    acceptedFiles.forEach(file => {
      parsedFiles.push({
        id: _.uniqueId("prefix-"),
        file: file,
        name: file.name,
        path: file.preview,
        status: STATUS_QUEUED,
        progress: 0,
        value: null
      })
    })
    if (!this.props.multiple) {
      this.setState({
        files: [parsedFiles[0]]
      }, () => this._triggerUpload())
    } else {
      this.setState({
        files: [
          ...this.state.files,
          ...parsedFiles
        ]
      }, () => this._triggerUpload())
    }
  }

  _triggerUpload() {
    this.state.files.forEach((file) => {
        if(file.status == STATUS_QUEUED) {
          this._startUploading(file)
        }
    })
  }

  async _startUploading(file) {
    const data = new FormData();
    data.append('file', file.file);
    data.append('filename', file.name);

    this._updateFile(file, {
      status: STATUS_UPLOADING
    });

    axios.post(Config.url + 'tools/upload', data, {
      onUploadProgress:  (progressEvent) => {
        let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        this._updateFile(file, {
          progress: percentCompleted
        })
      }
    })
      .then((response) => {
        if(response.data.success) {
          this._updateFile(file, {
            value: response.data.data.name,
            // path: Config.publicUrl + response.data.data.preview,
            status: STATUS_NEW
          })
        }
      })
      .catch((error) => {
        this._removeFile(file);
      });
  }

  _updateFile(file, data) {
    let files = [...this.state.files];

    let foundFile = files.find(x => x.id == file.id);

    if(foundFile) {
      let index = files.indexOf(foundFile);
      let newFile = {
        ...foundFile,
        ...data
      };
      files[index] = newFile;
      this.setState({
        files
      }, () => this._afterFilesUpdate());

    }
  }

  _removeFile(file) {
    let files = [...this.state.files];
    let index = files.indexOf(file);

    if(index >= 0) {
      files.splice(index, 1);
      this.setState({
        files
      })
    }
  }

  _afterFilesUpdate() {
    if(this.props.handler) {
      if(!this.props.multiple) {
        this.props.handler.handleInputChange(this.props.name, this.state.files[0] ? this.state.files[0].value : null)
      }
    }
  }

  _getDropzone() {

    if(!this.props.multiple && this.state.files.length > 0) return null;

    return (
      // <Dropzone
      //   accept=".jpg,.jpeg,.png"
      //   onDrop={this.handleDrop}
      //   multiple={this.props.multiple}
      //   style={{ display: 'inline-block', padding: 20, textAlign: 'center', border: '4px dashed #fff', borderRadius: 10 }}
      // >
      <Dropzone
        accept=".jpg,.jpeg,.png"
        onDrop={this.handleDrop}
        multiple={this.props.multiple}
        style={{ display: 'inline-block', padding: 0, textAlign: 'center',  borderRadius: 10 }}
      >
        <div style={{}}>
          <div style={{ width: '100%', flexDirection: 'column', alignItems: 'center', position: 'relative' }} className='uploadButton'>
            {/* <button type="file" value='upload' className="redButton" style={{background: 'white', borderRadius: 50, color: 'black'}}>BROWSE </button> */}
            <button type="file" value='upload' className="redButton" style={{background: 'white', borderRadius: 50, color: 'black'}}>{this.props.buttonLabel}</button>
            <input
              type="file" id="profile_pic" name="profile_pic" title=" "
              accept=".jpg, .jpeg, .png" onChange={this.onImageChange.bind(this)} style={{}} className="fileInput-addnewproject" />
            {/* <div style={{ color: '#fff', marginTop: 20 }}>
              <div><em className="fa fa-fw fa-upload" style={{ fontSize: '4em' }}></em></div>
              <div><span>or</span></div>
              <div><span>drag n' drop here</span></div>
            </div> */}
          </div>
        </div>
      </Dropzone>
    )
  }

  _getUploadedFiles() {
    if(!this.state.files.length) return null;

    let elements = [];

    const UploadedFile = (props) => this._getUploadedFileItem(props.file);

    this.state.files.forEach((file, index) => {
      elements.push(<UploadedFile file={file} key={index}/>)
    })

    return elements;
  }

  _getUploadedFileItem(file) {
    let bottomElement = null;

    if(file.status == STATUS_UPLOADING) {
      bottomElement = <div style={{marginTop: 10}}><ProgressBarComponent percentage={file.progress}/></div>
    } else {
      bottomElement = (
        <div style={{marginTop: 10}}>
          <a href="javascript:void(0)" onClick={() => this._removeFile(file)}>Remove</a>
        </div>
      )
    }

    return (
      <div className="file-preview" style={{display: 'inline-block', border: '1px solid #e0e0e0', padding: 10, textAlign: 'center'}}>
        <p>{file.name}</p>
        {/* <img src={file.path} style={{height: '400px', width: 'auto' }}/> */}
        <img src={file.path} style={{height: 'auto', maxWidth: 200 }}/>
        {bottomElement}
      </div>
    )
  }

  render() {
    let dropzone = this._getDropzone();
    let uploadedFiles = this._getUploadedFiles();
    return (
      <div style={{}}>
        <label style={{ color: 'gray' }}>{this.props.label}</label>
        <div>
          {dropzone}
          {uploadedFiles}
        </div>
      </div>
    )
  }
}

AppUploadField.defaultProps = {
  // label: '*Upload the main project image',
  accept: '.jpg,.jpeg,.png',
  multiple: false
}



// WEBPACK FOOTER //
// ./src/elements/form/fields/AppUploadField.js